type StarIconProps = {
  fill?: string
  id?: string
  width?: number
  height?: number
  className?: string
}

export const StarIcon: React.FC<StarIconProps> = ({
  fill,

  width,
  height,
  id,
  className,
}) => {
  return (
    <div className={'ICON ' + className} id={id}>
      <svg
        width={width || '16'}
        height={height || width || '16'}
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_10431_2959)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10.6046 4.97405L8.0002 0.509277L5.39573 4.97405L0.574219 6.45759L3.88423 9.76757L2.77386 15.3194L8.0002 12.9616L13.2265 15.3194L12.1161 9.76757L15.4261 6.45759L10.6046 4.97405Z"
            fill={fill || '#D43D27'}
          />
        </g>
        <defs>
          <clipPath id="clip0_10431_2959">
            <rect width="16" height="16" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </div>
  )
}
